var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.464,
    height: 23.446,
    viewBox: "0 0 17.464 23.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Location_1014404",
    transform: "translate(-398.35 220)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(398.852 -219.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M30.068,11.5a8.344,8.344,0,0,0-8.2,7.881,8.566,8.566,0,0,0,1.751,5.633l6.129,8.756a.416.416,0,0,0,.35.175.382.382,0,0,0,.35-.175l6.1-8.756A8.643,8.643,0,0,0,38.3,19.352,8.387,8.387,0,0,0,30.068,11.5Zm5.75,13.018-5.75,8.26-5.779-8.26a7.669,7.669,0,0,1-1.576-5.079,7.533,7.533,0,0,1,7.355-7.064,7.484,7.484,0,0,1,7.326,7.064A7.669,7.669,0,0,1,35.818,24.518Z",
    transform: "translate(-21.852 -11.5)",
    fill: "none",
    stroke: "#26262A",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M42,28.8a3.328,3.328,0,1,0,3.3,3.327A3.32,3.32,0,0,0,42,28.8Zm0,5.779a2.452,2.452,0,1,1,2.423-2.452A2.442,2.442,0,0,1,42,34.579Z",
    transform: "translate(-33.782 -23.75)",
    fill: "none",
    stroke: "#26262A",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.c3a6f3dfd0a85e14bc4199bbff52ac8d.svg";
export { ForwardRef as ReactComponent };